// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.depot-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.depot-panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  pointer-events: auto;
  width: clamp(640px, 56vw, 980px);
  max-height: 88vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: ink-enter 0.16s ease-out;
}
.depot-panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .depot-panel {
    animation: none;
  }
}

.depot-header {
  flex: 0 0 auto;
  display: flex;
  align-items: baseline;
  gap: 14px;
  padding: 18px 24px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.depot-header-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.depot-header-hold {
  font-size: 15px;
  font-weight: 600;
  color: var(--gold-light);
}

.depot-body {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1 1 auto;
  min-height: 0;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  scrollbar-gutter: stable;
}
.depot-body::-webkit-scrollbar {
  width: 6px;
}
.depot-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.depot-body--message {
  align-items: center;
  justify-content: center;
  min-height: 160px;
}

.depot-message {
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
  text-align: center;
}
.depot-message--error {
  color: #d9786d;
}

.depot-gauges {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.depot-gauge {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.depot-gauge-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
}
.depot-gauge-label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}
.depot-gauge-value {
  font-size: 13px;
  color: #aeaba2;
  font-variant-numeric: tabular-nums;
}
.depot-gauge-track {
  height: 6px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 3px;
}
.depot-gauge-fill {
  height: 100%;
  background: var(--gold-main);
  transition: width 0.2s ease;
}
.depot-gauge-fill--full {
  background: #d9786d;
}

.depot-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 6px 16px;
  padding: 9px 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  font-size: 14px;
  color: #aeaba2;
}
.depot-info-fee {
  color: #ebe8e1;
  font-weight: 600;
}
.depot-info-users {
  color: #8d8a82;
}

.depot-feeedit {
  display: flex;
  align-items: center;
  gap: 10px;
}
.depot-feeedit-label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  flex: 1 1 auto;
}

.depot-input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  display: block;
}
.depot-input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.depot-input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.depot-input--fee {
  width: 84px;
  flex: 0 0 auto;
}

.depot-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  min-height: 0;
}

.depot-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
.depot-column-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.depot-list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  height: 280px;
  display: flex;
  flex-direction: column;
  scrollbar-gutter: stable;
}
.depot-list::-webkit-scrollbar {
  width: 6px;
}
.depot-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.depot-empty {
  padding: 18px 14px;
  font-size: 14px;
  line-height: 1.5;
  color: #8d8a82;
}

.depot-row {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  text-align: left;
  background: transparent;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  border-left: 2px solid transparent;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.depot-row:first-child {
  border-top-color: transparent;
}
.depot-row-name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.depot-row-count {
  flex: 0 0 auto;
  font-variant-numeric: tabular-nums;
  color: #aeaba2;
}
.depot-row:hover {
  background: rgba(255, 255, 255, 0.04);
  color: var(--gold-light);
}
.depot-row:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.depot-row--selected {
  background: rgba(255, 255, 255, 0.08);
  border-left-color: var(--gold-main);
  color: var(--gold-light);
}

.depot-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 18px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.depot-selection {
  flex: 1 1 200px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.depot-selection-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--gold-light);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.depot-selection-hint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}

.depot-stepper {
  display: flex;
  align-items: center;
  gap: 6px;
}
.depot-stepper-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  width: 32px;
  padding: 8px 0;
  font-size: 16px;
}
.depot-stepper-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.depot-stepper-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.depot-stepper-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.depot-stepper-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.depot-stepper-input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: 72px;
  text-align: center;
  font-variant-numeric: tabular-nums;
  -moz-appearance: textfield;
}
.depot-stepper-input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.depot-stepper-input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.depot-stepper-input::-webkit-outer-spin-button, .depot-stepper-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.depot-stepper-input:disabled {
  opacity: 0.5;
}

.depot-actions-buttons {
  display: flex;
  gap: 8px;
}

.depot-close-row {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.depot-hint {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #8d8a82;
}
.depot-hint kbd {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 12px;
  padding: 2px 8px;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
}

.depot-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.depot-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.depot-button:active:not(:disabled) {
  transform: translateY(1px);
}
.depot-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.depot-button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.depot-button:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.depot-button--ghost {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.2);
}
.depot-button--ghost:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.depot-button--quiet {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.depot-button--quiet:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.depot-button--sm {
  padding: 5px 10px;
  font-size: 13px;
}

@media (max-width: 760px) {
  .depot-panel {
    width: 96vw;
  }
  .depot-columns, .depot-gauges {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/depot/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AALA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yDDiBU;ACVZ;;AAJA;EDiBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EC3BA,oBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EDuJA,mCAAA;ACzIF;ADFE;EAAI,sBAAA;ACKN;ADwIE;EChKF;IDgK4C,eAAA;ECpI1C;AACF;;AAlBA;EACE,cAAA;EACA,aAAA;EACA,qBAAA;EACA,SAAA;EACA,uBAAA;EACA,kDAAA;AAqBF;AAnBE;EDqBA,kDA3BW;EA4BX,gBAAA;EACA,eCtBqB;EDuBrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ACyCP;AAvBE;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;AAyBJ;;AArBA;EDuHE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECvHA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,wBAAA;AA0BF;ADyFE;EAAuB,UAAA;ACtFzB;ADuFE;EAA6B,oCAAA;EAAsC,kBAAA;ACnFrE;;AA9BA;EACE,mBAAA;EACA,uBAAA;EACA,iBAAA;AAiCF;;AA9BA;EDEE,eAAA;EACA,gBAAA;EACA,cA7CO;EC2CP,kBAAA;AAmCF;AAjCE;EAAW,cD3CJ;AC+ET;;AAhCA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAmCF;;AAhCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAmCF;AAjCE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,QAAA;AAmCJ;AAhCE;EDZA,eAAA;EACA,gBAAA;EACA,cAzDO;ACwGT;AAjCE;EACE,eAAA;EACA,cDzEK;EC0EL,kCAAA;AAmCJ;AAhCE;EACE,WAAA;EACA,gBAAA;EACA,+BDpFQ;ECqFR,2CAAA;EACA,kBAAA;AAkCJ;AA/BE;EACE,YAAA;EACA,4BAAA;EACA,2BAAA;AAiCJ;AA/BI;EAAU,mBDxFL;AC0HT;;AA7BA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;EACA,iBAAA;EDxEA,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECkGP,eAAA;EACA,cDvGO;ACyIT;AAhCE;EAAQ,cD1GH;EC0GqB,gBAAA;AAoC5B;AAnCE;EAAU,cDzGH;AC+IT;;AAnCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAsCF;AApCE;ED3DA,eAAA;EACA,gBAAA;EACA,cAzDO;ECoHL,cAAA;AAwCJ;;AApCA;EDLE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECDA,cAAA;AA+CF;AD5CE;EAAU,aAAA;EAAe,8BAAA;ACgD3B;AD/CE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACsD1G;AAxDE;EACE,WAAA;EACA,cAAA;AA0DJ;;AArDA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;AAwDF;;AArDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAwDF;AAtDE;ED9GA,kDA3BW;EA4BX,gBAAA;EACA,eC6GqB;ED5GrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECmJH,gBAAA;EACA,uBAAA;EACA,mBAAA;AA6DJ;;AAzDA;EDTE,gBAAA;EACA,qBAAA;EACA,qDAAA;EArHA,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECuJP,aAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AAgEF;AD3EE;EAAuB,UAAA;AC8EzB;AD7EE;EAA6B,oCAAA;EAAsC,kBAAA;ACiFrE;;AApEA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDpKO;AC2OT;;AApEA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,yDDvKU;ECwKV,eAAA;EACA,cDlLK;ECmLL,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,+CAAA;EACA,kCAAA;EACA,eAAA;EACA,kFAAA;AAuEF;AArEE;EAAgB,6BAAA;AAwElB;AAtEE;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAwEJ;AArEE;EACE,cAAA;EACA,kCAAA;EACA,cDvMK;AC8QT;AApEE;EACE,qCDhNS;ECiNT,wBAAA;AAsEJ;AAnEE;EACE,oCAAA;EACA,oBAAA;AAqEJ;AAlEE;EACE,qCAAA;EACA,mCAAA;EACA,wBAAA;AAoEJ;;AA/DA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,+CAAA;AAkEF;;AA/DA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAkEF;AAhEE;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAkEJ;AA/DE;EDpMA,eAAA;EACA,gBAAA;EACA,cAlDO;ACwTT;;AA/DA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAkEF;AAhEE;EDjMA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ECoLE,WAAA;EACA,cAAA;EACA,eAAA;AAiFJ;ADrQE;EAAyB,qCAAA;EAAuC,8BAAA;ACyQlE;ADxQE;EAA0B,0BAAA;AC2Q5B;AD1QE;EAAa,YAAA;EAAc,mBAAA;AC8Q7B;AD7QE;EAAkB,oCAAA;EAAsC,mBAAA;ACiR1D;AA7FE;EDnJA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;EC6IE,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,0BAAA;AAuGJ;ADrPE;EAAU,aAAA;EAAe,8BAAA;ACyP3B;ADxPE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC+P1G;AAhHI;EAC+B,wBAAA;EAA0B,SAAA;AAmH7D;AAlHI;EAAa,YAAA;AAqHjB;;AAjHA;EACE,aAAA;EACA,QAAA;AAoHF;;AAjHA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,+CAAA;AAoHF;;AAjHA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cDtSO;AC0ZT;AAlHE;EACE,yDDlSQ;ECmSR,eAAA;EACA,gBAAA;EACA,cD7SK;EC8SL,qCDnTS;ECoTT,2CAAA;EACA,kBAAA;AAoHJ;;AA/GA;EDvPE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EASA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;ACkWF;AD3WE;EAAyB,qCAAA;EAAuC,8BAAA;AC+WlE;AD9WE;EAA0B,0BAAA;ACiX5B;ADhXE;EAAa,YAAA;EAAc,mBAAA;ACoX7B;ADnXE;EAAkB,oCAAA;EAAsC,mBAAA;ACuX1D;AD/WE;EAAyB,6BAAA;EAA+B,+BAAA;ACmX1D;AApJE;EACE,cD3TG;EC4TH,qCAAA;EACA,sCD9TU;ACodd;AApJI;EACE,cDhUC;ECiUD,qCAAA;EACA,8BAAA;AAsJN;AAlJE;ED/NA,cArGO;EAsGP,uBAAA;EACA,yBAAA;ACoXF;ADlXE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACuXhF;AAxJE;ED3NA,iBAAA;EACA,eAAA;ACsXF;;AAvJA;EACE;IAAe,WAAA;EA2Jf;EA1JA;IAAgC,0BAAA;EA6JhC;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","// Regional depot (\"Entrepôt du fief\"). Centred modal, ink panel look shared\n// with the mailbox and the escape menu (see theme/_ink.scss).\n@use '../../theme/ink' as ink;\n\n.depot-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(2, 3, 8, 0.6);\n  pointer-events: none;\n  font-family: ink.$font-text;\n}\n\n.depot-panel {\n  @include ink.panel;\n  pointer-events: auto;\n  width: clamp(640px, 56vw, 980px);\n  max-height: 88vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  @include ink.enter;\n}\n\n.depot-header {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  padding: 18px 24px 14px;\n  border-bottom: 1px solid ink.$line;\n\n  &-title {\n    @include ink.title(26px);\n  }\n\n  &-hold {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--gold-light);\n  }\n}\n\n.depot-body {\n  @include ink.scroll;\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  scrollbar-gutter: stable;\n}\n\n.depot-body--message {\n  align-items: center;\n  justify-content: center;\n  min-height: 160px;\n}\n\n.depot-message {\n  @include ink.lead;\n  text-align: center;\n\n  &--error { color: ink.$danger; }\n}\n\n// Capacity gauges\n.depot-gauges {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.depot-gauge {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n\n  &-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 8px;\n  }\n\n  &-label {\n    @include ink.label;\n  }\n\n  &-value {\n    font-size: 13px;\n    color: ink.$text-2;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &-track {\n    height: 6px;\n    overflow: hidden;\n    background: ink.$ink-field;\n    border: 1px solid ink.$line;\n    border-radius: 3px;\n  }\n\n  &-fill {\n    height: 100%;\n    background: var(--gold-main);\n    transition: width 0.2s ease;\n\n    &--full { background: ink.$danger; }\n  }\n}\n\n// Fee line and Jarl editor\n.depot-info {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 6px 16px;\n  padding: 9px 12px;\n  @include ink.block;\n  font-size: 14px;\n  color: ink.$text-2;\n\n  &-fee { color: ink.$text; font-weight: 600; }\n  &-users { color: ink.$text-3; }\n}\n\n.depot-feeedit {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  &-label {\n    @include ink.label;\n    flex: 1 1 auto;\n  }\n}\n\n.depot-input {\n  @include ink.field;\n  display: block;\n\n  &--fee {\n    width: 84px;\n    flex: 0 0 auto;\n  }\n}\n\n// Two columns\n.depot-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  min-height: 0;\n}\n\n.depot-column {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n\n  &-title {\n    @include ink.title(18px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.depot-list {\n  @include ink.scroll;\n  @include ink.block;\n  height: 280px;\n  display: flex;\n  flex-direction: column;\n  scrollbar-gutter: stable;\n}\n\n.depot-empty {\n  padding: 18px 14px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: ink.$text-3;\n}\n\n.depot-row {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 12px;\n  font-family: ink.$font-text;\n  font-size: 14px;\n  color: ink.$text;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  border-top: 1px solid ink.$line;\n  border-left: 2px solid transparent;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:first-child { border-top-color: transparent; }\n\n  &-name {\n    flex: 1 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &-count {\n    flex: 0 0 auto;\n    font-variant-numeric: tabular-nums;\n    color: ink.$text-2;\n  }\n\n  &:hover {\n    background: ink.$ink-raised;\n    color: var(--gold-light);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--gold-light);\n    outline-offset: -2px;\n  }\n\n  &--selected {\n    background: rgba(255, 255, 255, 0.08);\n    border-left-color: var(--gold-main);\n    color: var(--gold-light);\n  }\n}\n\n// Quantity + actions\n.depot-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px 18px;\n  padding-top: 12px;\n  border-top: 1px solid ink.$line;\n}\n\n.depot-selection {\n  flex: 1 1 200px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n\n  &-name {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--gold-light);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &-hint {\n    @include ink.hint;\n  }\n}\n\n.depot-stepper {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  &-btn {\n    @include ink.button;\n    width: 32px;\n    padding: 8px 0;\n    font-size: 16px;\n  }\n\n  &-input {\n    @include ink.field;\n    width: 72px;\n    text-align: center;\n    font-variant-numeric: tabular-nums;\n    -moz-appearance: textfield;\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }\n    &:disabled { opacity: 0.5; }\n  }\n}\n\n.depot-actions-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.depot-close-row {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 24px;\n  border-top: 1px solid ink.$line;\n}\n\n.depot-hint {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: ink.$text-3;\n\n  kbd {\n    font-family: ink.$font-text;\n    font-size: 12px;\n    padding: 2px 8px;\n    color: ink.$text-2;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line;\n    border-radius: 4px;\n  }\n}\n\n// Primary by default; --ghost neutral, --quiet tertiary, --sm compact.\n.depot-button {\n  @include ink.button;\n  @include ink.button-primary;\n\n  &--ghost {\n    color: ink.$text;\n    background: rgba(255, 255, 255, 0.07);\n    border-color: ink.$line-strong;\n\n    &:hover:not(:disabled) {\n      color: ink.$text;\n      background: rgba(255, 255, 255, 0.12);\n      border-color: var(--gold-dark);\n    }\n  }\n\n  &--quiet {\n    @include ink.button-quiet;\n  }\n\n  &--sm {\n    @include ink.button-sm;\n  }\n}\n\n@media (max-width: 760px) {\n  .depot-panel { width: 96vw; }\n  .depot-columns, .depot-gauges { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
